export const data = [
  //1
  {
    key: "c3-01",
    title: "사랑해요",
    grade: "1권",
    cover: require("@data/assets/yellow/book1/images/cover.jpg"),
    background: require("@data/assets/yellow/book1/pages/page05.jpg"),
    song: {
      url: require("@data/assets/yellow/book1/sounds/page23.mp3"),
      title: "사랑해",
      caption: [
        "사랑해 사랑해 아빠 엄마 사랑해",
        "wǒ ài bàba wǒ ài bàba wǒ ài māma wǒ ài māma",
        "사랑해 사랑해 언니 오빠 사랑해",
        "wǒ ài jiějie wǒ ài jiějie  wǒ ài gēge  wǒ ài gēge",
        "사랑해 사랑해 내 동생 사랑해",
        "wǒ ài mèimei wǒ ài mèimei wǒ ài dìdi wǒ ài dìdi",
      ],
    },
    mov: {
      cn: "0d949cdb46727062e06c2dfa765b5015_01",
      en: "ec02655bbc74869f6317ba4b3de01907_01",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-03.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_01.mp3"),
          word: "妈妈|māma",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-02.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_02.mp3"),
          word: "爸爸|bàba",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-01.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_03.mp3"),
          word: "姐姐|jiějie",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-06.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_04.mp3"),
          word: "哥哥|gēge",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-05.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_05.mp3"),
          word: "妹妹|mèimei",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-04.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_06.mp3"),
          word: "弟弟|dìdi",
        },
        //

        {
          img: require("@data/assets/yellow/book1/images/img_Y1-08.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_07.mp3"),
          word: "我爱妈妈。|Wǒ ài māma.",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-07.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_08.mp3"),
          word: "我爱爸爸。|Wǒ ài bàba.",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-10.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_09.mp3"),
          word: "我爱姐姐。|Wǒ ài jiějie.",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-09.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_10.mp3"),
          word: "我爱哥哥。|Wǒ ài gēge.",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-12.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_11.mp3"),
          word: "我爱妹妹。|Wǒ ài mèimei.",
        },
        {
          img: require("@data/assets/yellow/book1/images/img_Y1-11.png"),
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_12.mp3"),
          word: "我爱弟弟。|Wǒ ài dìdi.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-03.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_01.mp3"),
        buttons: [{ ch2: "māma" }, { ch: "妈妈" }, { ko: "엄마" }],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-02.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_02.mp3"),
        buttons: [{ ch2: "bàba" }, { ch: "爸爸" }, { ko: "아빠" }],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-01.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_03.mp3"),
        buttons: [{ ch2: "jiějie" }, { ch: "姐姐" }, { ko: "언니, 누나" }],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-06.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_04.mp3"),
        buttons: [{ ch2: "gēge" }, { ch: "哥哥" }, { ko: "오빠, 형" }],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-05.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_05.mp3"),
        buttons: [{ ch2: "mèimei" }, { ch: "妹妹" }, { ko: "여동생" }],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-04.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_06.mp3"),
        buttons: [{ ch2: "dìdi" }, { ch: "弟弟" }, { ko: "남동생" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-08.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ ài māma." },
          { ch: "我爱妈妈。" },
          { ko: "나는 엄마를 사랑해요." },
        ],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-07.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ ài bàba." },
          { ch: "我爱爸爸。" },
          { ko: "나는 아빠를 사랑해요." },
        ],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-10.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ ài jiějie." },
          { ch: "我爱姐姐。" },
          { ko: "나는 언니(누나)를 사랑해요." },
        ],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-09.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ ài gēge." },
          { ch: "我爱哥哥。" },
          { ko: "나는 형(오빠)을 사랑해요." },
        ],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-12.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ ài mèimei." },
          { ch: "我爱妹妹。" },
          { ko: "나는 여동생을 사랑해요." },
        ],
      },
      {
        img: require("@data/assets/yellow/book1/images/img_Y1-11.png"),
        sound: require("@data/assets/yellow/book1/sounds/KC01_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ ài dìdi." },
          { ch: "我爱弟弟。" },
          { ko: "나는 남동생을 사랑해요." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_01.mp3"),
          img: require("@data/assets/yellow/book1/images/img_Y1-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_04.mp3"),
          answer: [
            [require("@data/assets/yellow/book1/images/img_Y1-06.png"), true],
            [require("@data/assets/yellow/book1/images/img_Y1-05.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/yellow/book1/sounds/KC01_W_03.mp3"),
          answer: [
            ["jiějie", true],
            ["dìdi", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/yellow/book1/pages/front.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/yellow/book1/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page04.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page06.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page08.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page10.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page12.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page14.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page16.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page18.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page20.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page22.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page23.jpg"),
        sound: require("@data/assets/yellow/book1/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/yellow/book1/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/yellow/book1/thumbnail/front.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page02.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page03.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page04.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page05.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page06.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page07.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page08.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page09.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page10.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page11.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page12.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page13.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page14.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page15.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page16.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page17.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page18.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page19.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page20.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page21.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page22.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page23.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page24.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page25.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page26.jpg"),
      require("@data/assets/yellow/book1/thumbnail/page27.jpg"),
    ],
  },
  //2
  {
    key: "c3-02",
    title: "누가 치즈를 가져갔을까?",
    grade: "2권",
    cover: require("@data/assets/yellow/book2/images/cover.jpg"),
    background: require("@data/assets/yellow/book2/pages/page05.jpg"),
    song: {
      url: require("@data/assets/yellow/book2/sounds/page23.mp3"),
      title: "직업을 말해 보아요",
      caption: [
        "직업을 말해 보아요 jǐngchá huàjiā kēxuéjiā",
        "tā shì jǐngchá jǐngchá tā shì huàjiā huàjiā",
        "tā shì kēxuéjiā kēxuéjiā",
        "직업을 말해 보아요 lǎoshī xuésheng chúshī",
        "tā shì lǎoshī lǎoshī tā shì xuésheng xuésheng",
        "tā shì chúshī chúshī",
      ],
    },
    mov: {
      cn: "3bb92ce12e02f87d6ffe38e0e82d91d5_02",
      en: "9775a66b7b37f8bdeb998e73f1043f5b_02",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-03.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_01.mp3"),
          word: "警察|jǐngchá",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-02.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_02.mp3"),
          word: "画家|huàjiā",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-01.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_03.mp3"),
          word: "科学家|kēxuéjiā",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-06.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_04.mp3"),
          word: "老师|lǎoshī",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-05.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_05.mp3"),
          word: "学生|xuésheng",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-04.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_06.mp3"),
          word: "厨师|chúshī ",
        },
        //

        {
          img: require("@data/assets/yellow/book2/images/img_Y2-08.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_07.mp3"),
          word: "我是警察。|Wǒ shì jǐngchá.",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-07.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_08.mp3"),
          word: "他是画家。|Tā shì huàjiā.",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-10.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_09.mp3"),
          word: "他是科学家。|Tā shì kēxuéjiā.",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-09.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_10.mp3"),
          word: "她是老师。|Tā shì lǎoshī.",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-12.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_11.mp3"),
          word: "我是学生。|Wǒ shì xuésheng. ",
        },
        {
          img: require("@data/assets/yellow/book2/images/img_Y2-11.png"),
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_12.mp3"),
          word: "他是厨师。|Tā shì chúshī.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-03.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_01.mp3"),
        buttons: [{ ch2: "jǐngchá" }, { ch: "警察" }, { ko: "경찰" }],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-02.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_02.mp3"),
        buttons: [{ ch2: "huàjiā" }, { ch: "画家" }, { ko: "화가" }],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-01.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_03.mp3"),
        buttons: [{ ch2: "kēxuéjiā" }, { ch: "科学家" }, { ko: "과학자" }],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-06.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_04.mp3"),
        buttons: [{ ch2: "lǎoshī" }, { ch: "老师" }, { ko: "선생님" }],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-05.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_05.mp3"),
        buttons: [{ ch2: "xuésheng" }, { ch: "学生" }, { ko: "학생" }],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-04.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_06.mp3"),
        buttons: [{ ch2: "chúshī " }, { ch: "厨师" }, { ko: "요리사" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-08.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ shì jǐngchá." },
          { ch: "我是警察。" },
          { ko: "나는 경찰입니다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-07.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_08.mp3"),
        buttons: [
          { ch2: "Tā shì huàjiā." },
          { ch: "他是画家。" },
          { ko: "그는 화가입니다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-10.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_09.mp3"),
        buttons: [
          { ch2: "Tā shì kēxuéjiā." },
          { ch: "他是科学家。" },
          { ko: "그는 과학자입니다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-09.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_10.mp3"),
        buttons: [
          { ch2: "Tā shì lǎoshī." },
          { ch: "她是老师。" },
          { ko: "그녀는 선생님입니다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-12.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ shì xuésheng. " },
          { ch: "我是学生。" },
          { ko: "나는 학생입니다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book2/images/img_Y2-11.png"),
        sound: require("@data/assets/yellow/book2/sounds/KC02_W_12.mp3"),
        buttons: [
          { ch2: "Tā shì chúshī." },
          { ch: "他是厨师。" },
          { ko: "그는 요리사입니다." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_02.mp3"),
          img: require("@data/assets/yellow/book2/images/img_Y2-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_03.mp3"),
          answer: [
            [require("@data/assets/yellow/book2/images/img_Y2-06.png"), false],
            [require("@data/assets/yellow/book2/images/img_Y2-01.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/yellow/book2/sounds/KC02_W_01.mp3"),
          answer: [
            ["jǐngchá", true],
            ["lǎoshī", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/yellow/book2/pages/front.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/yellow/book2/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page04.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page06.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page08.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page10.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page12.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page14.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page16.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page18.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page20.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page22.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page23.jpg"),
        sound: require("@data/assets/yellow/book2/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/yellow/book2/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/yellow/book2/thumbnail/front.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page02.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page03.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page04.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page05.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page06.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page07.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page08.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page09.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page10.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page11.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page12.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page13.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page14.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page15.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page16.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page17.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page18.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page19.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page20.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page21.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page22.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page23.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page24.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page25.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page26.jpg"),
      require("@data/assets/yellow/book2/thumbnail/page27.jpg"),
    ],
  },
  //3
  {
    key: "c3-03",
    title: "뭐가 보이니?",
    grade: "3권",
    cover: require("@data/assets/yellow/book3/images/cover.jpg"),
    background: require("@data/assets/yellow/book3/pages/page05.jpg"),
    song: {
      url: require("@data/assets/yellow/book3/sounds/page23.mp3"),
      title: "무엇을 보나요",
      caption: [
        "커다란 눈으로 무엇을 보나요",
        "shū shū shīzi kàn shū",
        "bàozhǐ bàozhǐ lǎohǔ kàn bàozhǐ",
        "mànhuàshū mànhuàshū láng kàn mànhuàshū",
        "동그란 눈으로 무엇을 보나요",
        "diànyǐng diànyǐng dàxiàng kàn diànyǐng",
        "dònghuàpiān dònghuàpiān māo kàn dònghuàpiān",
        "diànshì diànshì shé kàn diànshì",
      ],
    },
    mov: {
      cn: "2fad856e06425e92dae77c575552f3b1_03",
      en: "5694d2941b05f7af701afca5ce4da338_03",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-03.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_01.mp3"),
          word: "书|shū",
        },
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-02.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_02.mp3"),
          word: "报纸|bàozhǐ",
        },
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-01.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_03.mp3"),
          word: "漫画书|mànhuàshū",
        },
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-06.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_04.mp3"),
          word: "电影|diànyǐng",
        },
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-05.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_05.mp3"),
          word: "动画片|dònghuàpiān",
        },
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-04.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_06.mp3"),
          word: "电视|diànshì",
        },
        //

        {
          img: require("@data/assets/yellow/book3/images/img_Y3-08.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_07.mp3"),
          word: "狮子看书。|Shīzi kàn shū. ",
        },
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-07.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_08.mp3"),
          word: "老虎看报纸。 |Lǎohǔ kàn bàozhǐ. ",
        },
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-10.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_09.mp3"),
          word: "狼看漫画书。|Láng kàn mànhuàshū. ",
        },
        {
          img: require("@data/assets/yellow/book3/images/img_Y3-11.png"),
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_12.mp3"),
          word: "蛇看电视。|Shé kàn diànshì. ",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-03.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_01.mp3"),
        buttons: [{ ch2: "shū" }, { ch: "书" }, { ko: "책" }],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-02.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_02.mp3"),
        buttons: [{ ch2: "bàozhǐ" }, { ch: "报纸" }, { ko: "신문" }],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-01.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_03.mp3"),
        buttons: [{ ch2: "mànhuàshū" }, { ch: "漫画书" }, { ko: "만화책" }],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-06.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_04.mp3"),
        buttons: [{ ch2: "diànyǐng" }, { ch: "电影" }, { ko: "영화" }],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-05.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_05.mp3"),
        buttons: [
          { ch2: "dònghuàpiān" },
          { ch: "动画片" },
          { ko: "애니메이션" },
        ],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-04.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_06.mp3"),
        buttons: [{ ch2: "diànshì" }, { ch: "电视" }, { ko: "텔레비전" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-08.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_07.mp3"),
        buttons: [
          { ch2: "Shīzi kàn shū." },
          { ch: "狮子看书。" },
          { ko: "사자가 책을 본다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-07.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_08.mp3"),
        buttons: [
          { ch2: "Lǎohǔ kàn bàozhǐ." },
          { ch: "老虎看报纸。" },
          { ko: "호랑이가 신문을 본다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-10.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_09.mp3"),
        buttons: [
          { ch2: "Láng kàn mànhuàshū. " },
          { ch: "狼看漫画书。" },
          { ko: "늑대가 만화책을 본다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-09.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_10.mp3"),
        buttons: [
          { ch2: "Dàxiàng kàn diànyǐng. " },
          { ch: "大象看电影。" },
          { ko: "코끼리가 영화를 본다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-12.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_11.mp3"),
        buttons: [
          { ch2: "Māo kàn dònghuàpiān." },
          { ch: "猫看动画片。" },
          { ko: "고양이가 애니메이션을 본다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book3/images/img_Y3-11.png"),
        sound: require("@data/assets/yellow/book3/sounds/KC03_W_12.mp3"),
        buttons: [
          { ch2: "Shé kàn diànshì." },
          { ch: "蛇看电视。" },
          { ko: "뱀이 텔레비전을 본다." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_04.mp3"),
          img: require("@data/assets/yellow/book3/images/img_Y3-04.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_05.mp3"),
          answer: [
            [require("@data/assets/yellow/book3/images/img_Y3-05.png"), true],
            [require("@data/assets/yellow/book3/images/img_Y3-01.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/yellow/book3/sounds/KC03_W_06.mp3"),
          answer: [
            ["diànshì", true],
            ["bàozhǐ", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/yellow/book3/pages/front.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/yellow/book3/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page04.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page06.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page08.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page10.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page12.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page14.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page16.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page18.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page20.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page22.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page23.jpg"),
        sound: require("@data/assets/yellow/book3/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/yellow/book3/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/yellow/book3/thumbnail/front.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page02.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page03.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page04.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page05.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page06.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page07.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page08.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page09.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page10.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page11.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page12.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page13.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page14.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page15.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page16.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page17.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page18.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page19.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page20.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page21.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page22.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page23.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page24.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page25.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page26.jpg"),
      require("@data/assets/yellow/book3/thumbnail/page27.jpg"),
    ],
  },
  //4
  {
    key: "c3-04",
    title: "보물은 어디에 있을까?",
    grade: "4권",
    cover: require("@data/assets/yellow/book4/images/cover.jpg"),
    background: require("@data/assets/yellow/book4/pages/page05.jpg"),
    song: {
      url: require("@data/assets/yellow/book4/sounds/page23.mp3"),
      title: "어디 가나요",
      caption: [
        "바쁘게 바쁘게 어디 가나요",
        "tā qù gōngsī tā qù yīyuàn",
        "tā qù gōngsī tā qù yīyuàn",
        "즐겁게 즐겁게 어디 가나요",
        "tā qù xuéxiào tā qù yòu'éryuán",
        "tā qù xuéxiào tā qù yòu'éryuán",
        "신나게 신나게 어디 가나요",
        "tā qù gōngyuán tā qù chāoshì",
        "tā qù gōngyuán tā qù chāoshì",
      ],
    },
    mov: {
      cn: "bc8950ceaab6a35b96ed2135e084e4b6_04",
      en: "5d0e4a3f06b525abb34c5707f90c8fd4_04",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-03.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_01.mp3"),
          word: "公司|gōngsī",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-02.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_02.mp3"),
          word: "医院|yīyuàn",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-01.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_03.mp3"),
          word: "学校|xuéxiào",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-06.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_04.mp3"),
          word: "幼儿园|yòu'éryuán",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-05.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_05.mp3"),
          word: "公园|gōngyuán",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-04.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_06.mp3"),
          word: "超市|chāoshì",
        },
        //

        {
          img: require("@data/assets/yellow/book4/images/img_Y4-08.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_07.mp3"),
          word: "爸爸去公司。|Bàba qù gōngsī.",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-07.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_08.mp3"),
          word: "妈妈去医院。|Māma qù yīyuàn. ",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-10.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_09.mp3"),
          word: "他去学校。|Tā qù xuéxiào.",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-09.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_10.mp3"),
          word: "她去幼儿园。|Tā qù yòu'éryuán.",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-12.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_11.mp3"),
          word: "他去公园。|Tā qù gōngyuán. ",
        },
        {
          img: require("@data/assets/yellow/book4/images/img_Y4-11.png"),
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_12.mp3"),
          word: "她去超市。|Tā qù chāoshì. ",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-03.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_01.mp3"),
        buttons: [{ ch2: "gōngsī" }, { ch: "公司" }, { ko: "회사" }],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-02.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_02.mp3"),
        buttons: [{ ch2: "yīyuàn" }, { ch: "医院" }, { ko: "병원" }],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-01.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_03.mp3"),
        buttons: [{ ch2: "xuéxiào" }, { ch: "学校" }, { ko: "학교" }],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-06.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_04.mp3"),
        buttons: [{ ch2: "yòu'éryuán" }, { ch: "幼儿园" }, { ko: "유치원" }],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-05.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_05.mp3"),
        buttons: [{ ch2: "gōngyuán" }, { ch: "公园" }, { ko: "공원" }],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-04.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_06.mp3"),
        buttons: [{ ch2: "chāoshì" }, { ch: "超市" }, { ko: "슈퍼마켓" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-08.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_07.mp3"),
        buttons: [
          { ch2: "Bàba qù gōngsī." },
          { ch: "爸爸去公司。" },
          { ko: "아빠는 회사에 가신다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-07.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_08.mp3"),
        buttons: [
          { ch2: "Māma qù yīyuàn." },
          { ch: "妈妈去医院。" },
          { ko: "엄마는 병원에 가신다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-10.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_09.mp3"),
        buttons: [
          { ch2: "Tā qù xuéxiào." },
          { ch: "他去学校。" },
          { ko: "그는 학교에 간다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-09.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_10.mp3"),
        buttons: [
          { ch2: "Tā qù yòu'éryuán." },
          { ch: "她去幼儿园。" },
          { ko: "그녀는 유치원에 간다. " },
        ],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-12.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_11.mp3"),
        buttons: [
          { ch2: "Tā qù gōngyuán." },
          { ch: "他去公园。" },
          { ko: "그는 공원에 간다. " },
        ],
      },
      {
        img: require("@data/assets/yellow/book4/images/img_Y4-11.png"),
        sound: require("@data/assets/yellow/book4/sounds/KC04_W_12.mp3"),
        buttons: [
          { ch2: "Tā qù chāoshì." },
          { ch: "她去超市。" },
          { ko: "그녀는 슈퍼마켓에 간다." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_04.mp3"),
          img: require("@data/assets/yellow/book4/images/img_Y4-05.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_01.mp3"),
          answer: [
            [require("@data/assets/yellow/book4/images/img_Y4-06.png"), false],
            [require("@data/assets/yellow/book4/images/img_Y4-03.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/yellow/book4/sounds/KC04_W_03.mp3"),
          answer: [
            ["xuéxiào", true],
            ["yīyuàn", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/yellow/book4/pages/front.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/yellow/book4/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page04.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page06.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page08.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page10.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page12.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page14.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page16.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page18.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page20.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page22.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page23.jpg"),
        sound: require("@data/assets/yellow/book4/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/yellow/book4/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/yellow/book4/thumbnail/front.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page02.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page03.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page04.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page05.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page06.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page07.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page08.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page09.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page10.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page11.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page12.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page13.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page14.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page15.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page16.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page17.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page18.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page19.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page20.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page21.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page22.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page23.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page24.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page25.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page26.jpg"),
      require("@data/assets/yellow/book4/thumbnail/page27.jpg"),
    ],
  },
  //5
  {
    key: "c3-05",
    title: "알록달록 패션쇼",
    grade: "5권",
    cover: require("@data/assets/yellow/book5/images/cover.jpg"),
    background: require("@data/assets/yellow/book5/pages/page05.jpg"),
    song: {
      url: require("@data/assets/yellow/book5/sounds/page23.mp3"),
      title: "예쁘게 색칠해요",
      caption: [
        "빨강 파랑 검정으로 예쁘게 색칠해요",
        "wǒ xǐhuan hóngsè  hóngsè hóngsè",
        "wǒ xǐhuan lánsè  lánsè  lánsè",
        "wǒ xǐhuan hēisè  hēisè  hēisè",
        "노랑 초록 하양으로 예쁘게 색칠해요",
        "wǒ xǐhuan huángsè  huángsè huángsè",
        "wǒ xǐhuan <span style='font-family: sans-serif;'>lǜsè<span>   <span style='font-family: sans-serif;'>lǜsè<span>   <span style='font-family: sans-serif;'>lǜsè<span>",
        "wǒ xǐhuan báisè  báisè  báisè",
      ],
    },
    mov: {
      cn: "687f0cebd6df902d936898e95c723dd9_05",
      en: "d994fff411669575f4864dbc42352e3e_05",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-03.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_01.mp3"),
          word: "红色|hóngsè",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-02.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_02.mp3"),
          word: "蓝色|lánsè",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-01.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_03.mp3"),
          word: "黄色|huángsè",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-06.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_04.mp3"),
          word: "绿色|<span style='font-family: sans-serif;'>lǜsè<span>",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-05.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_05.mp3"),
          word: "黑色|hēisè",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-04.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_06.mp3"),
          word: "白色|báisè",
        },
        //

        {
          img: require("@data/assets/yellow/book5/images/img_Y5-08.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_07.mp3"),
          word: "我喜欢红色。|Wǒ xǐhuan hóngsè.",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-07.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_08.mp3"),
          word: "我喜欢蓝色。|Wǒ xǐhuan lánsè.",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-10.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_09.mp3"),
          word: "我喜欢黄色。|Wǒ xǐhuan huángsè.",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-09.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_10.mp3"),
          word: "我喜欢绿色。|Wǒ xǐhuan <span style='font-family: sans-serif;'>lǜsè<span>.",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-12.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_11.mp3"),
          word: "我喜欢黑色。|Wǒ xǐhuan hēisè.",
        },
        {
          img: require("@data/assets/yellow/book5/images/img_Y5-11.png"),
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_12.mp3"),
          word: "我喜欢白色。|Wǒ xǐhuan báisè.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-03.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_01.mp3"),
        buttons: [{ ch2: "hóngsè" }, { ch: "红色" }, { ko: "빨간색" }],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-02.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_02.mp3"),
        buttons: [{ ch2: "lánsè" }, { ch: "蓝色" }, { ko: "파란색" }],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-01.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_03.mp3"),
        buttons: [{ ch2: "huángsè" }, { ch: "黄色" }, { ko: "노란색" }],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-06.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_04.mp3"),
        buttons: [
          { ch2: "<span style='font-family: sans-serif;'>lǜsè<span>" },
          { ch: "绿色" },
          { ko: "초록색" },
        ],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-05.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_05.mp3"),
        buttons: [{ ch2: "hēisè" }, { ch: "黑色" }, { ko: "검은색" }],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-04.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_06.mp3"),
        buttons: [{ ch2: "báisè" }, { ch: "白色" }, { ko: "하얀색" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-08.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan hóngsè." },
          { ch: "我喜欢红色。" },
          { ko: "나는 빨간색을 좋하한다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-07.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan lánsè." },
          { ch: "我喜欢蓝色。" },
          { ko: "나는 파란색을 좋아한다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-10.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan huángsè." },
          { ch: "我喜欢黄色。" },
          { ko: "나는 노란색을 좋아한다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-09.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_10.mp3"),
        buttons: [
          {
            ch2: "Wǒ xǐhuan <span style='font-family: sans-serif;'>lǜsè<span>.",
          },
          { ch: "我喜欢绿色。" },
          { ko: "나는 초록색을 좋아한다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-12.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan hēisè." },
          { ch: "我喜欢黑色。" },
          { ko: "나는 검은색을 좋아한다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book5/images/img_Y5-11.png"),
        sound: require("@data/assets/yellow/book5/sounds/KC05_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ xǐhuan báisè." },
          { ch: "我喜欢白色。" },
          { ko: "나는 하얀색을 좋아한다." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_05.mp3"),
          img: require("@data/assets/yellow/book5/images/img_Y5-04.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_02.mp3"),
          answer: [
            [require("@data/assets/yellow/book5/images/img_Y5-01.png"), false],
            [require("@data/assets/yellow/book5/images/img_Y5-02.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/yellow/book5/sounds/KC05_W_06.mp3"),
          answer: [
            ["lánsè", false],
            ["báisè", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/yellow/book5/pages/front.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/yellow/book5/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page04.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page06.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page08.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page10.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page12.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page14.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page16.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page18.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page20.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page22.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page23.jpg"),
        sound: require("@data/assets/yellow/book5/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/yellow/book5/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/yellow/book5/thumbnail/front.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page02.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page03.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page04.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page05.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page06.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page07.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page08.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page09.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page10.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page11.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page12.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page13.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page14.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page15.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page16.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page17.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page18.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page19.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page20.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page21.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page22.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page23.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page24.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page25.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page26.jpg"),
      require("@data/assets/yellow/book5/thumbnail/page27.jpg"),
    ],
  },
  //6
  {
    key: "c3-06",
    title: "무인도 탈출작전",
    grade: "6권",
    cover: require("@data/assets/yellow/book6/images/cover.jpg"),
    background: require("@data/assets/yellow/book6/pages/page05.jpg"),
    song: {
      url: require("@data/assets/yellow/book6/sounds/page23.mp3"),
      title: "무엇이 있니?",
      caption: [
        "필통 속에는 무엇이 있니",
        "qiānbǐ qiānbǐ  wǒ yǒu qiānbǐ",
        "xiàngpí xiàngpí wǒ yǒu xiàngpí",
        "jiǎndāo jiǎndāo wǒ yǒu jiǎndāo",
        "가방 속에는 무엇이 있니",
        "làbǐ làbǐ wǒ yǒu làbǐ",
        "bǐhé bǐhé wǒ yǒu bǐhé",
        "bǐjìběn bǐjìběn wǒ yǒu bǐjìběn",
      ],
    },
    mov: {
      cn: "077a937daa97c3f4b7d978a9073dd484_06",
      en: "db3f7db40380644b15ecac3d5841f40d_06",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-03.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_01.mp3"),
          word: "铅笔|qiānbǐ",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-02.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_02.mp3"),
          word: "笔记本|bǐjìběn",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-01.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_03.mp3"),
          word: "橡皮|xiàngpí",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-06.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_04.mp3"),
          word: "蜡笔|làbǐ",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-05.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_05.mp3"),
          word: "笔盒|bǐhé",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-04.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_06.mp3"),
          word: "剪刀|jiǎndāo",
        },
        //

        {
          img: require("@data/assets/yellow/book6/images/img_Y6-08.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_07.mp3"),
          word: "我有铅笔。|Wǒ yǒu qiānbǐ.",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-07.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_08.mp3"),
          word: "我有笔记本。|Wǒ yǒu bǐjìběn.",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-10.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_09.mp3"),
          word: "我有橡皮。|Wǒ yǒu xiàngpí.",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-09.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_10.mp3"),
          word: "我有蜡笔。|Wǒ yǒu làbǐ.",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-12.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_11.mp3"),
          word: "我有笔盒。|Wǒ yǒu bǐhé.",
        },
        {
          img: require("@data/assets/yellow/book6/images/img_Y6-11.png"),
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_12.mp3"),
          word: "我有剪刀。|Wǒ yǒu jiǎndāo.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-03.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_01.mp3"),
        buttons: [{ ch2: "qiānbǐ" }, { ch: "铅笔" }, { ko: "연필" }],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-02.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_02.mp3"),
        buttons: [{ ch2: "bǐjìběn" }, { ch: "笔记本" }, { ko: "공책" }],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-01.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_03.mp3"),
        buttons: [{ ch2: "xiàngpí" }, { ch: "橡皮" }, { ko: "지우개" }],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-06.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_04.mp3"),
        buttons: [{ ch2: "làbǐ" }, { ch: "蜡笔" }, { ko: "크레용" }],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-05.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_05.mp3"),
        buttons: [{ ch2: "bǐhé" }, { ch: "笔盒" }, { ko: "필통" }],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-04.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_06.mp3"),
        buttons: [{ ch2: "jiǎndāo" }, { ch: "剪刀" }, { ko: "가위" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-08.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu qiānbǐ." },
          { ch: "我有铅笔。" },
          { ko: "나는 연필이 있다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-07.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu bǐjìběn." },
          { ch: "我有笔记本。" },
          { ko: "나는 공책이 있다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-10.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu xiàngpí." },
          { ch: "我有橡皮。" },
          { ko: "나는 지우개가 있다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-09.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu làbǐ." },
          { ch: "我有蜡笔。" },
          { ko: "나는 크레용이 있다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-12.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu bǐhé." },
          { ch: "我有笔盒。" },
          { ko: "나는 필통이 있다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book6/images/img_Y6-11.png"),
        sound: require("@data/assets/yellow/book6/sounds/KC06_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ yǒu jiǎndāo." },
          { ch: "我有剪刀。" },
          { ko: "나는 가위가 있다." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_02.mp3"),
          img: require("@data/assets/yellow/book6/images/img_Y6-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_03.mp3"),
          answer: [
            [require("@data/assets/yellow/book6/images/img_Y6-03.png"), false],
            [require("@data/assets/yellow/book6/images/img_Y6-01.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/yellow/book6/sounds/KC06_W_06.mp3"),
          answer: [
            ["làbǐ", false],
            ["jiǎndāo", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/yellow/book6/pages/front.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/yellow/book6/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page04.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page06.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page08.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page10.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page12.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page14.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page16.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page18.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page20.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page22.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page23.jpg"),
        sound: require("@data/assets/yellow/book6/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/yellow/book6/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/yellow/book6/thumbnail/front.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page02.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page03.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page04.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page05.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page06.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page07.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page08.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page09.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page10.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page11.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page12.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page13.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page14.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page15.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page16.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page17.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page18.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page19.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page20.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page21.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page22.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page23.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page24.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page25.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page26.jpg"),
      require("@data/assets/yellow/book6/thumbnail/page27.jpg"),
    ],
  },
  //7
  {
    key: "c3-07",
    title: "마법 공의 비밀",
    grade: "7권",
    cover: require("@data/assets/yellow/book7/images/cover.jpg"),
    background: require("@data/assets/yellow/book7/pages/page05.jpg"),
    song: {
      url: require("@data/assets/yellow/book7/sounds/page23.mp3"),
      title: "몸 튼튼 마음 튼튼",
      caption: [
        "으샤으샤 열심히 운동하면 튼튼해져요 몸 튼튼 마음 튼튼",
        "tā dǎ pīngpāngqiú tā dǎ pīngpāngqiú",
        "tā dǎ lánqiú tā dǎ lánqiú",
        "tā dǎ gāo'ěrfūqiú tā dǎ gāo'ěrfūqiú",
        "랄라랄라 즐겁게 운동하면 튼튼해져요 몸 튼튼 마음 튼튼",
        "tā dǎ yǔmáoqiú tā dǎ yǔmáoqiú",
        "tā tī zúqiú tā tī zúqiú",
        "tā dǎ bàngqiú tā dǎ bàngqiú",
      ],
    },
    mov: {
      cn: "bbd39d05d7b5f47bd5c5f4f7a1252e35_07",
      en: "7d4b97e714f28e3587aa40103660c0b4_07",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-03.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_01.mp3"),
          word: "乒乓球|pīngpāngqiú",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-02.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_02.mp3"),
          word: "篮球|lánqiú",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-01.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_03.mp3"),
          word: "高尔夫球|gāo'ěrfūqiú",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-06.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_04.mp3"),
          word: "羽毛球|yǔmáoqiú",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-05.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_05.mp3"),
          word: "足球|zúqiú",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-04.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_06.mp3"),
          word: "棒球|bàngqiú",
        },
        //

        {
          img: require("@data/assets/yellow/book7/images/img_Y7-08.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_07.mp3"),
          word: "他打乒乓球。|Tā dǎ pīngpāngqiú.",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-07.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_08.mp3"),
          word: "他打篮球。|Tā dǎ lánqiú.",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-10.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_09.mp3"),
          word: "他打高尔夫球。|Tā dǎ gāo'ěrfūqiú.",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-09.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_10.mp3"),
          word: "他打羽毛球。|Tā dǎ yǔmáoqiú.",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-12.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_11.mp3"),
          word: "他踢足球。|Tā tī zúqiú.",
        },
        {
          img: require("@data/assets/yellow/book7/images/img_Y7-11.png"),
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_12.mp3"),
          word: "他打棒球。|Tā dǎ bàngqiú.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-03.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_01.mp3"),
        buttons: [{ ch2: "pīngpāngqiú" }, { ch: "乒乓球" }, { ko: "탁구" }],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-02.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_02.mp3"),
        buttons: [{ ch2: "lánqiú" }, { ch: "篮球" }, { ko: "농구" }],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-01.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_03.mp3"),
        buttons: [{ ch2: "gāo'ěrfūqiú" }, { ch: "高尔夫球" }, { ko: "골프" }],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-06.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_04.mp3"),
        buttons: [{ ch2: "yǔmáoqiú" }, { ch: "羽毛球" }, { ko: "배드민턴" }],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-05.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_05.mp3"),
        buttons: [{ ch2: "zúqiú" }, { ch: "足球" }, { ko: "축구" }],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-04.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_06.mp3"),
        buttons: [{ ch2: "bàngqiú" }, { ch: "棒球" }, { ko: "야구" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-08.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_07.mp3"),
        buttons: [
          { ch2: "Tā dǎ pīngpāngqiú." },
          { ch: "他打乒乓球。" },
          { ko: "그는 탁구를 친다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-07.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_08.mp3"),
        buttons: [
          { ch2: "Tā dǎ lánqiú." },
          { ch: "他打篮球。" },
          { ko: "그는 농구를 한다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-10.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_09.mp3"),
        buttons: [
          { ch2: "Tā dǎ gāo'ěrfūqiú." },
          { ch: "他打高尔夫球。" },
          { ko: "그는 골프를 친다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-09.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_10.mp3"),
        buttons: [
          { ch2: "Tā dǎ yǔmáoqiú." },
          { ch: "他打羽毛球。" },
          { ko: "그는 배드민턴을 친다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-12.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_11.mp3"),
        buttons: [
          { ch2: "Tā tī zúqiú." },
          { ch: "他踢足球。" },
          { ko: "그는 축구를 한다. " },
        ],
      },
      {
        img: require("@data/assets/yellow/book7/images/img_Y7-11.png"),
        sound: require("@data/assets/yellow/book7/sounds/KC07_W_12.mp3"),
        buttons: [
          { ch2: "Tā dǎ bàngqiú." },
          { ch: "他打棒球。" },
          { ko: "그는 야구를 한다." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_03.mp3"),
          img: require("@data/assets/yellow/book7/images/img_Y7-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_05.mp3"),
          answer: [
            [require("@data/assets/yellow/book7/images/img_Y7-05.png"), true],
            [require("@data/assets/yellow/book7/images/img_Y7-06.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/yellow/book7/sounds/KC07_W_01.mp3"),
          answer: [
            ["pīngpāngqiú", true],
            ["yǔmáoqiú", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/yellow/book7/pages/front.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/yellow/book7/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page04.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page06.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page08.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page10.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page12.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page14.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page16.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page18.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page20.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page22.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page23.jpg"),
        sound: require("@data/assets/yellow/book7/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/yellow/book7/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/yellow/book7/thumbnail/front.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page02.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page03.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page04.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page05.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page06.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page07.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page08.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page09.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page10.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page11.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page12.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page13.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page14.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page15.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page16.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page17.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page18.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page19.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page20.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page21.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page22.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page23.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page24.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page25.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page26.jpg"),
      require("@data/assets/yellow/book7/thumbnail/page27.jpg"),
    ],
  },
  //8
  {
    key: "c3-08",
    title: "달려라 씽씽",
    grade: "8권",
    cover: require("@data/assets/yellow/book8/images/cover.jpg"),
    background: require("@data/assets/yellow/book8/pages/page05.jpg"),
    song: {
      url: require("@data/assets/yellow/book8/sounds/page23.mp3"),
      title: "무엇을 탈까요?",
      caption: [
        "qí qí  zuò zuò  무엇을 탈까요",
        "따르릉  zìxíngchē tāmen qí zìxíngchē",
        "슝슝  fēijī tāmen zuò fēijī",
        "칙칙폭폭 huǒchē  tāmen zuò huǒchē",
        "붕붕  qìchē tāmen zuò qìchē",
        "쌩쌩  dìtiě tāmen zuò dìtiě",
        "부르릉 gōnggòngqìchē tāmen zuò gōnggòngqìchē",
      ],
    },
    mov: {
      cn: "08434b81809db7f89e2747f17efaa9a7_08",
      en: "79b74112885495c8af5b1cd61593ce51_08",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-03.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_01.mp3"),
          word: "自行车|zìxíngchē",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-02.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_02.mp3"),
          word: "飞机|fēijī",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-01.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_03.mp3"),
          word: "火车|huǒchē",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-06.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_04.mp3"),
          word: "公共汽车|gōnggòngqìchē",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-05.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_05.mp3"),
          word: "汽车|qìchē",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-04.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_06.mp3"),
          word: "地铁|dìtiě",
        },
        //

        {
          img: require("@data/assets/yellow/book8/images/img_Y8-08.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_07.mp3"),
          word: "他骑自行车。|Tā qí zìxíngchē.",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-07.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_08.mp3"),
          word: "他们坐飞机。|Tāmen zuò fēijī.",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-10.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_09.mp3"),
          word: "他们坐火车。|Tāmen zuò huǒchē.",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-12.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_11.mp3"),
          word: "他们坐汽车。|Tāmen zuò qìchē. ",
        },
        {
          img: require("@data/assets/yellow/book8/images/img_Y8-11.png"),
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_12.mp3"),
          word: "他们坐地铁。|Tāmen zuò dìtiě.",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-03.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_01.mp3"),
        buttons: [{ ch2: "zìxíngchē" }, { ch: "自行车" }, { ko: "자전거" }],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-02.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_02.mp3"),
        buttons: [{ ch2: "fēijī" }, { ch: "飞机" }, { ko: "비행기" }],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-01.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_03.mp3"),
        buttons: [{ ch2: "huǒchē" }, { ch: "火车" }, { ko: "기차" }],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-06.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_04.mp3"),
        buttons: [{ ch2: "gōnggòngqìchē" }, { ch: "公共汽车" }, { ko: "버스" }],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-05.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_05.mp3"),
        buttons: [{ ch2: "qìchē" }, { ch: "汽车" }, { ko: "자동차" }],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-04.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_06.mp3"),
        buttons: [{ ch2: "dìtiě" }, { ch: "地铁" }, { ko: "지하철" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-08.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_07.mp3"),
        buttons: [
          { ch2: "Tā qí zìxíngchē." },
          { ch: "他骑自行车。" },
          { ko: "그는 자전거를 탄다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-07.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_08.mp3"),
        buttons: [
          { ch2: "Tāmen zuò fēijī." },
          { ch: "他们坐飞机。" },
          { ko: "그들은 비행기를 탄다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-10.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_09.mp3"),
        buttons: [
          { ch2: "Tāmen zuò huǒchē." },
          { ch: "他们坐火车。" },
          { ko: "그들은 기차를 탄다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-09.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_10.mp3"),
        buttons: [
          { ch2: "Tāmen zuò gōnggòngqìchē." },
          { ch: "他们坐公共汽车。" },
          { ko: "그들은 버스를 탄다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-12.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_11.mp3"),
        buttons: [
          { ch2: "Tāmen zuò qìchē. " },
          { ch: "他们坐汽车。" },
          { ko: "그들은 자동차를 탄다." },
        ],
      },
      {
        img: require("@data/assets/yellow/book8/images/img_Y8-11.png"),
        sound: require("@data/assets/yellow/book8/sounds/KC08_W_12.mp3"),
        buttons: [
          { ch2: "Tāmen zuò dìtiě." },
          { ch: "他们坐地铁。" },
          { ko: "그들은 지하철을 탄다." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_04.mp3"),
          img: require("@data/assets/yellow/book8/images/img_Y8-06.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_06.mp3"),
          answer: [
            [require("@data/assets/yellow/book8/images/img_Y8-04.png"), true],
            [require("@data/assets/yellow/book8/images/img_Y8-03.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/yellow/book8/sounds/KC08_W_03.mp3"),
          answer: [
            ["huǒchē", true],
            ["qìchē", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/yellow/book8/pages/front.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/yellow/book8/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page04.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page06.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page08.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page10.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page12.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page14.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page16.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page18.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page20.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page22.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page23.jpg"),
        sound: require("@data/assets/yellow/book8/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/yellow/book8/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/yellow/book8/thumbnail/front.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page02.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page03.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page04.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page05.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page06.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page07.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page08.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page09.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page10.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page11.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page12.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page13.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page14.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page15.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page16.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page17.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page18.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page19.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page20.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page21.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page22.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page23.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page24.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page25.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page26.jpg"),
      require("@data/assets/yellow/book8/thumbnail/page27.jpg"),
    ],
  },
];
